<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // if the urls are url/en || url/en/ || url/pt || url/pt/
    var currentUrl = window.location.pathname;
    if (currentUrl == "/en" || currentUrl == "/pt" || currentUrl == "/en/" || currentUrl == "/pt/") {
      this.$router.push({name: 'Home'}) 
    };
  },
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';
  .c-header
  {
    background-color: #ddb427;
  }
  .c-header-nav-link
  {
    color: #fff !important;
  }
  .c-subheader
  {
    display: none;
  }
  .c-sidebar-brand > svg
  {
    display: none !important;
  }
.c-sidebar {
    color: #fff;
    background: #ddb427;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.vdp-datepicker input{
  width: 100%;
}
.vdp-datepicker input:focus{
  outline: none;
}

/* Global classes */
.disabled > input,
.disabled > .dropdown
{
  pointer-events: none;
  opacity: 0.7;
}

input[type='checkbox']
{
  width: 25px;
  height: 25px;
  cursor: pointer;
  margin-top: 0;
}
.gap-1
{
  gap: 1rem;
}
.cursor-pointer{
  cursor: pointer;
}
</style>
